// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3fylP","title":"InfoRow_title__3_E-p"};